exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flip-list-move {\ntransition: transform 0.5s;\n}\n.no-move {\ntransition: transform 0s;\n}\n.ghost {\nopacity: 0.5;\nbackground: #c8ebfb;\n}\n.handle {\n    float: left;\n}\n\n\n", ""]);

// exports
